module.exports = __webpack_public_path__ + "static/a-wrinkle-in-time-9a3266b9daaa118b35b21abddbb2b4b6.jpg";